module.exports = __webpack_public_path__ + "img/icon-transport.994c675.png";